/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Unknown_FileInputs */

const en_issue_unknown_file = /** @type {(inputs: Issue_Unknown_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you cannot use this file for this product`)
};

/**
* | output |
* | --- |
* | "you cannot use this file for this product" |
*
* @param {Issue_Unknown_FileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_unknown_file = /** @type {((inputs?: Issue_Unknown_FileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Unknown_FileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_unknown_file(inputs)
});